// extracted by mini-css-extract-plugin
module.exports = {"icon":"DropDownIcon-module_icon__2o825SWEs0qoANMYkVVLGF"};